<template lang="pug">
  section.article
    Section(:img="article.img", :title="article.title", :undertitle="article.undertitle", :profession="article.profession", :alignment="article.alignment")
    .spacer
      Credits(:credits="article.credits" v-if="article.credits")
    .spacer
      Sharer(
        :baseurl="config.baseurl", :slug="$route.path", :title="article.share.title", :description="article.share.description", :img="config.img",:hashtag="config.hashtag", :brandtitle="config.brandtitle", :reporttitle="config.reporttitle")

    Content(:article="article")
    Related
</template>

<script>
import { mapState } from 'vuex'
import Section from '@/components/Section'
import Credits from '@/components/Credits'
import Sharer from '@/components/Sharer'
import Content from '@/components/Content'
import Related from '@/components/Related'

export default {
  components: {
    Section,
    Credits,
    Sharer,
    Content,
    Related
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState([
      'config'
    ]),
    article(){
      const article = this.$store.getters.getArticle(this.slug)
      if(typeof article === 'undefined'){
        this.$router.push({name: 'home'})
      }
      return article
    },
  }
}
</script>
<style lang="scss" scoped>
  .spacer{
    padding: 2rem 0;
  }
  .spacer+.spacer{
    padding: 0 0 2rem;
  }
  .content{
    padding: 4rem 1rem;
  }
  .block{
    max-width: $maxwidth;
    margin: 0 auto;
    padding: 1rem 0;
  }
  .block-wide{
    max-width: $overwidth;
    margin: 0 auto;
    padding: 1rem 0;
  }
  .paragraph-dropcap{
    text-indent: 0;
    &:first-letter {
      float: left;
      text-transform: uppercase;
      font-weight: 900;
      font-family: 'cap', sans-serif;
      font-size: 640%;
      text-transform: uppercase;
      line-height: 90%;
      padding-right: 8px;
      margin-left: -6px;
    }
  }

  .block-special{
    max-width: $uberwidth;
    margin: 0 auto;
    position: relative;
    .text{
      position: absolute;
      bottom: 0;
      right: 0;
      max-width: 33%;
      background-color: rgba(0,0,0,0.6);
      color: white;
      padding: 2rem;
      text-align: right;
      @media (max-width: 800px){
        max-width: none;
      }
      h3{
        font-weight: 600;
        line-height: 100%;
        letter-spacing: -3px;
        font-family: 'col', sans-serif;
        text-shadow: 1px 1px 1px black;
        @include fluid-type(360px,
          1440px,
          48px,
          72px);
        color: white;
      }
    }
  }
</style>

